import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Heading, Text, Stack, Badge, Flex, Divider, Button } from '@chakra-ui/react';
import { useCombinedStore } from '../../../store/hooks/useCombinedStore';

const FlightDetail = () => {
    const { id } = useParams<{ id: string; }>();
    const { flights } = useCombinedStore();
    const flight = flights.find(f => f._id === id);
    const cardsBorderRadii="8px";

    if (!flight) return <Text>Flight not found</Text>;

    return (
        <Box w="100%" mx="auto" p={6} bg="white" borderRadius={cardsBorderRadii} boxShadow="md">
            <Flex justify="space-between" align="center" mb={4}>
                <Heading size="lg">{flight.airline}</Heading>
                <Badge colorScheme="teal" fontSize="sm">Flight #{flight._id}</Badge>
            </Flex>

            <Stack spacing={3}>
                <Flex justify="space-between">
                    <Text fontWeight="bold">From:</Text> <Text>{flight.from}</Text>
                    <Text fontWeight="bold">To:</Text> <Text>{flight.to}</Text>
                </Flex>

                <Flex justify="space-between">
                    <Text fontWeight="bold">Departure:</Text> <Text>{flight.departureTime || 'N/A'}</Text>
                    <Text fontWeight="bold">Arrival:</Text> <Text>{flight.arrivalTime || 'N/A'}</Text>
                </Flex>

                <Divider />

                <Text fontWeight="bold">Price:</Text>
                <Text fontSize="xl" color="green.600">${flight.price || 'N/A'}</Text>

                <Button w={'150px'} colorScheme="teal" mt={4}>Book Now</Button>
            </Stack>
        </Box>
    );
};

export default FlightDetail;
